module.exports = __webpack_public_path__ + "static/media/mail-icon.b8b2177e.svg";